import { render } from "./ReferencesPages.vue?vue&type=template&id=8d98da58"
import script from "./ReferencesPages.vue?vue&type=script&lang=js"
export * from "./ReferencesPages.vue?vue&type=script&lang=js"

import "./ReferencesPages.vue?vue&type=style&index=0&id=8d98da58&lang=css"
script.render = render

export default script